<template>
  <consumer-loan-form
    v-model="form"
    :errors="errors"
    :loading="storing"
    submit-label="Save"
    @submit="update"
  />
</template>
<script>
  import { errorHandler } from '@/extra-functions/store.extra'
  import consumerLoanRepository from '@/repositories/consumer-loan.repository'

  export default {
    name: 'EditConsumerLoan',
    components: {
      consumerLoanForm: () =>
        import('@/views/dashboard/components/consumer-loans/Form'),
    },
    props: {
      propConsumerLoan: Object,
      propConsumerId: String,
    },
    data () {
      return {
        form: {
          crNumber: null,
          name: null,
          dateOfReciept: null,
          dateDue: null,
        },
        errors: [],
        storing: false,
      }
    },
    watch: {
      propConsumerLoan (consumerLoan) {
        this.form = {
          crNumber: consumerLoan.id,
          name: consumerLoan.loanee_name,
          dateOfReciept: consumerLoan.date_loaned,
          dateDue: consumerLoan.date_due,
        }
      },
    },
    methods: {
      update () {
        if (!this.storing) {
          this.storing = true
          this.errors = []
          const id = this.propConsumerLoan.id
          const consumer = this.propConsumerId
          const data = {
            id: this.form.crNumber,
            loanee_name: this.form.name,
            date_loaned: this.form.dateOfReciept,
            date_due: this.form.dateDue,
          }
          consumerLoanRepository.update(consumer, { id, data })
            .then(() => { })
            .catch(errors => { this.errors = errorHandler(errors) })
            .then(() => { this.storing = false })
        }
      },
    },
  }
</script>
